import type { FaireProductEntity } from "../../entity_types/product";

export const p_t73a882ktv: FaireProductEntity = {
  token: "p_t73a882ktv",
  type: "product",
  name: "Agate Slices.",
  brandToken: "b_8h5sk43qpz",
  brandName: "Down To Earth",
  imageUrl:
    "https://cdn.faire.com/fastly/b87eda07559a8231f6ef30fb830c49495f93a7e44fc1f213d59392c9525dbf7c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1cff8b95e2bd9847a7e9fd838af6ec26c08b6870baf7409bb4f0ed6c52ec5efd.jpeg",
    "https://cdn.faire.com/fastly/940541a14dd592cfa6632a9711317608dc61cdb0611be220dcf89f76bbf3a6dd.jpeg",
    "https://cdn.faire.com/fastly/b2e6df7af0e19f60412e32a95dfee29e54a40092b24acc3005ccb21c200a790e.jpeg",
    "https://cdn.faire.com/fastly/8c45139cb30a9f95c4442986f7cbe1444693ff443f881aa7273e1026da973eb1.jpeg",
    "https://cdn.faire.com/fastly/64baf0ed8369b694f6befcf6f10906b6eb91cf91a971fb6c924c691a411af255.jpeg",
    "https://cdn.faire.com/fastly/90150dc5990a8d26e0ddd4ae902ea9a38d058dbfb0b134e80d65f8c92cfabdaa.jpeg",
    "https://cdn.faire.com/fastly/e1fc4dd7a740febbe11081edee11ff9b77f63e4a4194a331768d8fbbb3026c77.jpeg",
    "https://cdn.faire.com/fastly/dfc0f1630561d48f941186d95fa1642e62c2cee785681acc833338dabc3ce0fd.jpeg",
    "https://cdn.faire.com/fastly/1a7f592f1196cd00ca007941c5f2fcbbaf92dc1ce7f056c81f9d1a71c830520a.jpeg",
    "https://cdn.faire.com/fastly/7d7c969f80ebf2595c61a13f2e12ba8c03df76a8aab60dcba8e2dda754b96a83.jpeg",
    "https://cdn.faire.com/fastly/6210faa6326cd50d7620d6dd44d78558bbd5103dcfeda6aa756a66b30e6d9955.jpeg",
  ],
  priceDollars: 8.31,
  description:
    "Add natural beauty and vibrant color to your space with our Agate Slices. Each slice showcases the stunning banding and organic patterns that make agate so beloved, with polished faces that highlight the stone’s unique layers and depth.\n\nMeasuring approximately 3 to 4 inches in diameter, these versatile pieces are perfect for altar décor, crystal grids, display trays, coasters, or creative projects. Available in an assortment of colors, every slice offers its own one of a kind look.\n\nBecause these are natural stones, variations in color, pattern, shape, and exact size are to be expected.\n",
  tags: [],
  msrpDollars: 16.63,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:08.646Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
